// // App.js
// import React from "react";
// import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
// import { ConfigProvider } from "antd"; // Import ConfigProvider
// import Navbar from "./components/Navbar.jsx";
// import Home from "./components/pages/Home.jsx";
// import AboutHKS from "./components/pages/AboutHKS.jsx";
// import Contact from "./components/pages/ContactPage.jsx";
// import Register from "./components/pages/Register.jsx";
// import Login from "./components/pages/Login.jsx";
// import "./App.css";
// import Footer from "./components/Footer";

// function App() {
//   return (
//     <ConfigProvider
//       theme={{
//         token: {
//           // Optional: Customize theme if needed
//           colorPrimary: "#1890ff",
//         },
//       }}
//     >
//       <Router>
//         <div className="App">
//           <Navbar />
//           <Routes>
//             <Route path="/" element={<Home />} />
//             <Route path="/about" element={<AboutHKS />} />
//             <Route path="/contact" element={<Contact />} />
//             <Route path="/register" element={<Register />} />
//             <Route path="/login" element={<Login />} />
//           </Routes>
//         </div>
//         <Footer/>
//       </Router>
//     </ConfigProvider>
//   );
// }

// // export default App;
// import React from "react";
// import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
// import { ConfigProvider } from "antd"; // Import ConfigProvider
// import Navbar from "./components/Navbar.jsx";
// import Home from "./components/pages/Home.jsx";
// import AboutHKS from "./components/pages/AboutHKS.jsx";
// import Contact from "./components/pages/ContactPage.jsx";
// import Register from "./components/pages/Register.jsx";
// import Login from "./components/pages/Login.jsx";
// import "./App.css";
// import Footer from "./components/Footer";

// function App() {
//   return (
//     <ConfigProvider
//       theme={{
//         token: {
//           // Optional: Customize theme if needed
//           colorPrimary: "#1890ff",
//         },
//       }}
//     >
//       <Router>
//         <AppContent />
//       </Router>
//     </ConfigProvider>
//   );
// }

// // New component to manage the content inside Router
// function AppContent() {
//   const location = useLocation();  // Now correctly using useLocation inside Router
//   const isExcludedPage = location.pathname === "/login" || location.pathname === "/register";

//   return (
//     <div className="App">
//       {/* Conditionally render Navbar based on the current route */}
//       {!isExcludedPage && <Navbar />}

//       <Routes>
//         <Route path="/" element={<Home />} />
//         <Route path="/about" element={<AboutHKS />} />
//         <Route path="/contact" element={<Contact />} />
//         <Route path="/register" element={<Register />} />
//         <Route path="/login" element={<Login />} />
//       </Routes>

//       {/* Conditionally render Footer based on the current route */}
//       {!isExcludedPage && <Footer />}
//     </div>
//   );
// }

// export default App;
import React from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { ConfigProvider } from "antd"; // Import ConfigProvider
import Navbar from "./components/Navbar.jsx";
import Home from "./components/pages/Home.jsx";
import AboutHKS from "./components/pages/AboutHKS.jsx";
import Contact from "./components/pages/ContactPage.jsx";
import Register from "./components/pages/Register.jsx";
import Login from "./components/pages/Login.jsx";
import DirectFinanceScheme from "./components/pages/DirectFinanceScheme.js"; // Import the new component
import MarginMoneyScheme from "./components/pages/MarginMoneyScheme.js"; // Import or create this component
import "./App.css";
import Footer from "./components/Footer";

function App() {
  return (
    <ConfigProvider
      theme={{
        token: {
          // Optional: Customize theme if needed
          colorPrimary: "#1890ff",
        },
      }}
    >
      <Router>
        <AppContent />
      </Router>
    </ConfigProvider>
  );
}

// New component to manage the content inside Router
function AppContent() {
  const location = useLocation(); // Correctly using useLocation inside Router
  const isExcludedPage = location.pathname === "/login" || location.pathname === "/register";

  return (
    <div className="App">
      {/* Conditionally render Navbar based on the current route */}
      {!isExcludedPage && <Navbar />}

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<AboutHKS />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/register" element={<Register />} />
        <Route path="/login" element={<Login />} />
        <Route path="/direct-finance-scheme" element={<DirectFinanceScheme />} />
        <Route path="/margin-money-scheme" element={<MarginMoneyScheme />} /> {/* Add this route */}
      </Routes>

      {/* Conditionally render Footer based on the current route */}
      {!isExcludedPage && <Footer />}
    </div>
  );
}

export default App;